/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ikprowoche2Inputs */

const de__field_ikprowoche2 = /** @type {(inputs: _Field_Ikprowoche2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intensivkurse pro Woche`)
};

/**

* @param {_Field_Ikprowoche2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ikprowoche2 = /** @type {((inputs?: _Field_Ikprowoche2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ikprowoche2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_ikprowoche2(inputs)
});
export { _field_ikprowoche2 as "_field_ikProWoche" }